import React from 'react';
import { AppBar, Box, Button, Container, Stack, Toolbar, Typography } from '@mui/material';
import LoginIcon from '@mui/icons-material/Login';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { Link } from 'react-router-dom';
import { BRANDING } from '../config/branding';

const navLinks = [
  { label: 'Inicio', to: '/' },
  { label: 'Productos', to: '/catalogo' },
  { label: 'Servicios', to: '/servicios' },
  { label: 'Contacto', to: '/contacto' },
];

const NavigationBar = () => (
  <AppBar
    position="sticky"
    color="transparent"
    sx={{
      position: 'relative',
      boxShadow: '0 15px 45px rgba(2,6,23,0.45)',
      background:
        'linear-gradient(120deg, rgba(4,7,29,0.95) 0%, rgba(15,23,42,0.92) 45%, rgba(30,41,59,0.95) 100%)',
      backdropFilter: 'blur(20px)',
      borderBottom: '1px solid rgba(99,102,241,0.35)',
      '&::after': {
        content: '""',
        position: 'absolute',
        left: 0,
        bottom: 0,
        width: '100%',
        height: 2,
        background:
          'linear-gradient(90deg, rgba(129,140,248,0) 0%, rgba(139,92,246,0.8) 50%, rgba(129,140,248,0) 100%)',
        boxShadow: '0 0 20px rgba(139,92,246,0.4)',
      },
    }}
  >
    <Container maxWidth="lg">
      <Toolbar disableGutters sx={{ minHeight: 80, justifyContent: 'space-between' }}>
        <Box>
          <Typography variant="h6" sx={{ fontWeight: 700, color: '#f8fafc' }}>
            {BRANDING.companyName}
          </Typography>
          <Typography variant="caption" sx={{ color: 'rgba(148,163,184,0.9)' }}>
            {BRANDING.companyTagline}
          </Typography>
        </Box>

        <Stack
          direction="row"
          spacing={2}
          alignItems="center"
          sx={{ display: { xs: 'none', md: 'flex' } }}
        >
          {navLinks.map((link) => {
            const buttonProps = { component: Link, to: link.to };
            return (
              <Button
                key={link.to || link.label}
                color="inherit"
                sx={{
                  textTransform: 'none',
                  fontWeight: 600,
                  letterSpacing: 0.5,
                  position: 'relative',
                  px: 1.5,
                  color: 'rgba(241,245,249,0.85)',
                  transition: 'color 0.3s ease',
                  '&::after': {
                    content: '""',
                    position: 'absolute',
                    left: 0,
                    bottom: -6,
                    width: '100%',
                    height: 2,
                    background:
                      'linear-gradient(90deg, rgba(96,165,250,0), rgba(96,165,250,0.8), rgba(96,165,250,0))',
                    transform: 'scaleX(0)',
                    transformOrigin: 'center',
                    transition: 'transform 0.3s ease',
                  },
                  '&:hover': {
                    color: '#82aaff',
                  },
                  '&:hover::after': {
                    transform: 'scaleX(1)',
                  },
                }}
                {...buttonProps}
              >
                {link.label}
              </Button>
            );
          })}
        </Stack>

        <Stack direction="row" spacing={1}>
          <Button
            component={Link}
            to="/login"
            color="inherit"
            startIcon={<LoginIcon />}
            sx={{
              borderRadius: 999,
              textTransform: 'none',
              px: 2.5,
              border: '1px solid rgba(148,163,184,0.3)',
              color: 'rgba(226,232,240,0.85)',
              transition: 'all 0.3s ease',
              backgroundColor: 'rgba(15,23,42,0.3)',
              '&:hover': {
                border: '1px solid rgba(226,232,240,0.9)',
                boxShadow: '0 0 15px rgba(82,109,255,0.3)',
                color: '#e4e8ff',
                backgroundColor: 'rgba(30,41,59,0.6)',
              },
            }}
          >
            Ingresar
          </Button>
          <Button
            component={Link}
            to="/catalogo"
            variant="contained"
            endIcon={<ArrowForwardIcon />}
            sx={{
              borderRadius: 999,
              textTransform: 'none',
              fontWeight: 600,
              px: 3,
              background: 'linear-gradient(90deg, #4c5fff 0%, #6366f1 50%, #8b5cf6 100%)',
              boxShadow: '0 10px 25px rgba(99,102,241,0.4)',
              '&:hover': {
                background: 'linear-gradient(90deg, #7dd3fc 0%, #60a5fa 50%, #818cf8 100%)',
                boxShadow: '0 12px 30px rgba(125,211,252,0.35)',
              },
            }}
          >
            Explorar
          </Button>
        </Stack>
      </Toolbar>
    </Container>
  </AppBar>
);

export default NavigationBar;
